import { Controller, Form, FormProvider } from 'react-hook-form';
import { isNil } from 'lodash';
import { Box, Button, FormControl, FormHelperText } from '@mui/material';
import { t } from 'i18next';

import { CustomModal } from '@components';
import { theme } from '@store';

import { useAddMembers } from './hooks';
import { SearchField } from '../../../../components/SearchField';

interface IAddMembersProps {
  teamId: string;
}

export const AddMembers = ({ teamId }: IAddMembersProps) => {
  const {
    control,
    isOpen,
    handleClose,
    handleOnClick,
    isSubmitting,
    onSubmit,
    teamEligibleUsers,
    watch,
    formMethods,
    searchQuery,
    setSearchQuery,
  } = useAddMembers({
    id: teamId,
  });

  return (
    <>
      <Button
        color='secondary'
        variant='contained'
        sx={{
          width: '50%',
          fontWeight: 'medium',
          fontSize: '0.8rem',
          lineHeight: '22px',
          color: 'white',
        }}
        onClick={handleOnClick}
      >
        {t('adminPanel.teams.drawer.addMembers')}
      </Button>
      <CustomModal
        isOpen={isOpen}
        onClose={handleClose}
        title={t('adminPanel.teams.drawer.membersTab.title')}
        isLoading={isSubmitting}
      >
        <FormProvider {...formMethods}>
          <Form
            control={control}
            onSubmit={e => onSubmit(e.event)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: 0,
            }}
          >
            <Controller
              name='member'
              control={control}
              render={({ field, fieldState: { error } }) => {
                return (
                  <FormControl fullWidth>
                    <SearchField
                      {...field}
                      options={teamEligibleUsers}
                      placeholder={t(
                        'adminPanel.teams.drawer.membersTab.members',
                      )}
                      onValueChange={event => field.onChange(event)}
                      search={searchQuery}
                      onSearchChange={setSearchQuery}
                      error={!isNil(error)}
                      optional
                    />
                    <FormHelperText error={!isNil(error)}>
                      {error ? error.message : null}
                    </FormHelperText>
                  </FormControl>
                );
              }}
            />

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '8px',
                position: 'sticky',
                bottom: 0,
                paddingY: 3,
                backgroundColor: theme.palette.common.white,
                zIndex: 3,
              }}
            >
              <Button
                variant='text'
                sx={{
                  fontSize: '0,875rem',
                  fontWeight: 'medium',
                  lineHeight: '24px',
                }}
                disabled={isSubmitting}
                onClick={handleClose}
              >
                {t('general.cancel')}
              </Button>
              <Button
                type='submit'
                variant='contained'
                color='secondary'
                sx={{
                  fontSize: '0,875rem',
                  fontWeight: 'medium',
                  lineHeight: '24px',
                  color: 'white',
                }}
                disabled={isSubmitting || !watch('member')}
              >
                {t('general.ADD')}
              </Button>
            </Box>
          </Form>
        </FormProvider>
      </CustomModal>
    </>
  );
};
